"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._EnableFormSubmit = exports._DisableFormSubmit = exports._OverwriteIndirectFormSubmit = exports._WriteDropdownField = exports._UpdateRenderOfRadioField = exports._WriteRadioField = exports._WriteCheckboxField = exports._ClearFields = exports._ReadRadioField = exports._WriteField = exports._GetFieldDomObj = exports._ReadField = exports._PrefillHiddenFields = exports._PrefillFields = exports._ReadFieldFromLocalstorage = exports._ReadFieldValue = exports._ReadAllFields = exports._RemoveFieldFromLocalstorage = exports._SaveFieldInLocalstorage = exports._SaveCustomerContractInLocalstorage = exports._CreateFormFields = exports._ValidateAnyField = exports._ValidateFields = exports._GenerateField = exports._FilterMappingsBasedOnFields = exports._FilterMappingsBasedOnKey = exports._ShouldPrefillFromLocalStorage = void 0;
var cash_dom_1 = __importDefault(require("cash-dom"));
var lodash_1 = __importDefault(require("lodash"));
var translation_1 = __importDefault(require("../services/translation"));
var jquery_helper_const_1 = require("./dom-crud/jquery-helper.const");
var error_helper_const_1 = require("./error-handling/error-helper.const");
var input_mapping_const_1 = require("./input.mapping.const");
var validate_iban_1 = require("./forms/validate-iban");
var object_service_1 = require("../services/object-service");
var settings_service_1 = require("../services/settings.service");
var _ShouldPrefillFromLocalStorage = function () { var _a; return ((_a = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService).get) === null || _a === void 0 ? void 0 : _a.prefillFromLocalStorage) !== false; };
exports._ShouldPrefillFromLocalStorage = _ShouldPrefillFromLocalStorage;
var _FilterMappingsBasedOnKey = function (mappings, key, value) {
    return Object.fromEntries(Object.entries(mappings).filter(function (a) { return a[1][key] === value; }));
};
exports._FilterMappingsBasedOnKey = _FilterMappingsBasedOnKey;
/**
 * You can use that to remove fieldmaps or fields from mappings to customize the form you want to validate
 * @param mappings
 * @param filterMappings
 * @returns
 */
var _FilterMappingsBasedOnFields = function (mappings, filter) {
    var _a;
    var filterMappings = filter;
    if (filter === null || filter === void 0 ? void 0 : filter.uid) {
        //If you filter by one field we convert it to a filter mapping
        filterMappings = (_a = {}, _a[filter.uid] = filter, _a);
    }
    var filterUIds = Object.values(filterMappings).map(function (a) { return a.uid; });
    var resultMapping = {};
    for (var key in mappings) {
        var mapping = mappings[key];
        if (!filterUIds.includes(mapping.uid)) {
            resultMapping[key] = mapping;
        }
    }
    return resultMapping;
};
exports._FilterMappingsBasedOnFields = _FilterMappingsBasedOnFields;
var _GenerateField = function (container, field) {
    var _a;
    var fieldEl;
    if (field.type === 'dropdown') {
        var selectField = (0, cash_dom_1.default)('<select>').attr('data-get', field.uid).attr('data-set', field.uid);
        fieldEl = (0, cash_dom_1.default)('<div>').append(selectField);
        container.append(fieldEl);
    }
    else if (field.type === 'text' || field.type === 'iban') {
        var inputField = (0, cash_dom_1.default)('<input>')
            .attr('data-get', field.uid)
            .attr('placeholder', (_a = field.placeholder) !== null && _a !== void 0 ? _a : '')
            .attr('data-set', field.uid);
        fieldEl = (0, cash_dom_1.default)('<div>').append(inputField);
        container.append(fieldEl);
    }
    else {
        console.log('NO TYPE DEFINED CANT GENERATE FIELD ', field);
    }
    if (field === null || field === void 0 ? void 0 : field.label) {
        fieldEl.prepend((0, cash_dom_1.default)("<label>".concat(field.label, "</label>")));
    }
    return fieldEl;
};
exports._GenerateField = _GenerateField;
/**
 * Finds all input fields on the page / container and checks there state
 * @param $container
 * @param $ignoreHiddenFields:
 * @returns
 */
var _ValidateFields = function ($container, options, saveInLocalStorage) {
    var _a, _b, _c;
    if (options === void 0) { options = {
        showErrors: true,
        showSuccess: false,
        animateToFirstError: true,
        mappings: input_mapping_const_1._AllMappings,
    }; }
    if (saveInLocalStorage === void 0) { saveInLocalStorage = false; }
    options.showErrors = (_a = options.showErrors) !== null && _a !== void 0 ? _a : true;
    options.showSuccess = (_b = options.showSuccess) !== null && _b !== void 0 ? _b : false;
    options.animateToFirstError = (_c = options.animateToFirstError) !== null && _c !== void 0 ? _c : true;
    var mappingResult = {};
    var valid = true;
    var invalidFields = [];
    for (var key in options.mappings) {
        var field = options.mappings[key];
        if ((0, exports._GetFieldDomObj)(field).length === 0) {
            if (options === null || options === void 0 ? void 0 : options.generateFieldsIfNotExists) {
                (0, exports._GenerateField)($container, field);
            }
            else if (field === null || field === void 0 ? void 0 : field.ignoreValidationIfNotExisting) {
                //NOTE: if ignore optionals set we assume you dont want to validate optional fields that are not even represented as DOM object
                continue;
            }
        }
        var result = (0, exports._ValidateAnyField)($container, field, options);
        console.log('field', field.uid, field, 'is valid:', result.valid, result);
        // save result in local storage, even if its invalid
        if (saveInLocalStorage) {
            var fieldValue = (0, exports._ReadFieldValue)(field);
            localStorage.setItem(field.uid, fieldValue);
        }
        if (result.valid === false) {
            valid = false;
            invalidFields.push(__assign(__assign({}, field), { error: result.error }));
            continue;
        }
        else {
            mappingResult = lodash_1.default.merge(mappingResult, result.data);
        }
    }
    if (!valid && options.animateToFirstError === true) {
        (0, error_helper_const_1._ScrollToFirstErrorField)($container);
    }
    return { valid: valid, data: mappingResult, invalidFields: invalidFields };
};
exports._ValidateFields = _ValidateFields;
/**
 * Validates a field with their settings
 * @param $container
 * @param field
 * @param options
 * @returns
 */
var _ValidateAnyField = function ($container, field, options) {
    var _a, _b;
    if (options === void 0) { options = {
        showErrors: true,
        showSuccess: false,
    }; }
    options.showErrors = (_a = options.showErrors) !== null && _a !== void 0 ? _a : true;
    options.showSuccess = (_b = options.showSuccess) !== null && _b !== void 0 ? _b : false;
    var domObject = (0, exports._GetFieldDomObj)(field, $container);
    var mappingResult = {};
    // if (field?.component) {
    //   const component = field.component();
    //   return {
    //     ...component.validateComponent(),
    //     data: component.readValue(),
    //   };
    // }
    var valid = true;
    (0, error_helper_const_1._RemoveStatusFromDomObject)(domObject);
    var errorMessage = '';
    var value = (0, exports._ReadFieldValue)(field);
    console.log('Got value', value, 'for field', field.uid);
    //IF its required and we have no value in input field, localstorage, or default - the field is invalid
    var visible = (0, jquery_helper_const_1._IsVisible)(domObject);
    if ((field === null || field === void 0 ? void 0 : field.required) && !(value === null || value === void 0 ? void 0 : value.length) && (0, jquery_helper_const_1._IsVisible)(domObject)) {
        valid = false;
        if (options === null || options === void 0 ? void 0 : options.showErrors) {
            (0, error_helper_const_1._AddErrorToDomObject)(domObject, translation_1.default.t('This is required'));
        }
        return {
            valid: valid,
            data: mappingResult,
            error: translation_1.default.t('This is required'),
        };
    }
    if (field === null || field === void 0 ? void 0 : field.disabled) {
        domObject.attr('disabled', 'true');
    }
    if ((field === null || field === void 0 ? void 0 : field.regex) && (0, jquery_helper_const_1._IsVisible)(domObject)) {
        var testResult = new RegExp(field.regex, 'g').test(value);
        if (options.showSuccess && testResult) {
            valid = true;
            (0, error_helper_const_1._AddSuccessToDomObject)(domObject, (field === null || field === void 0 ? void 0 : field.hideSuccessMessage) ? '' : undefined);
        }
        if (testResult === false) {
            valid = false;
            errorMessage = field.regexError;
            if (options.showErrors) {
                (0, error_helper_const_1._AddErrorToDomObject)(domObject, field.regexError);
            }
        }
    }
    if (field.type === 'iban') {
        var validIban = (0, validate_iban_1._IsIbanValid)(value);
        if (validIban === false) {
            (0, error_helper_const_1._AddErrorToDomObject)(domObject, translation_1.default.t('noValidIBAN'));
            return {
                valid: validIban,
                data: mappingResult,
                error: translation_1.default.t('noValidIBAN'),
            };
        }
    }
    lodash_1.default.set(mappingResult, field.uid, value);
    return {
        valid: valid,
        data: mappingResult,
        error: errorMessage,
    };
};
exports._ValidateAnyField = _ValidateAnyField;
/**
 * Creates input fields that are missing for module inside data-get="auto-form-fields" container
 * @param $container
 * @param refObjectAttr
 * @param attr
 */
var _CreateFormFields = function ($container, options) {
    var _a;
    if (options === void 0) { options = {
        refObjectAttr: 'auto-form-fields',
        mappings: input_mapping_const_1._AllMappings,
        attr: {},
    }; }
    var refObject = $container.find("[data-get=\"".concat(options.refObjectAttr, "\"]"));
    if (refObject.length) {
        var inputElements = [];
        for (var key in options.mappings) {
            var field = options.mappings[key];
            if ($container.find("[data-get=\"".concat(field.uid, "\"]"))) {
                //already exists
            }
            else {
                inputElements.push((0, cash_dom_1.default)('<input>').attr({
                    id: (_a = field === null || field === void 0 ? void 0 : field.legacy) === null || _a === void 0 ? void 0 : _a.id,
                    placeholder: field.uid,
                    'data-get': field.uid,
                }));
            }
        }
        refObject.append(inputElements);
    }
    else {
        console.error('CREATE FORM FIELDS CALLED WITHOUT [data-get="' + options.refObjectAttr + '"]');
    }
};
exports._CreateFormFields = _CreateFormFields;
var _SaveCustomerContractInLocalstorage = function (customerContract) {
    for (var key in input_mapping_const_1._AllMappings) {
        var field = input_mapping_const_1._AllMappings[key];
        var value = lodash_1.default.get(customerContract, field.uid);
        if (value) {
            (0, exports._SaveFieldInLocalstorage)(field, value);
        }
    }
};
exports._SaveCustomerContractInLocalstorage = _SaveCustomerContractInLocalstorage;
/**
 * Save legacy and new fields in localstorage
 * @param field
 * @param value
 */
var _SaveFieldInLocalstorage = function (field, before) {
    var _a;
    var value = String(before);
    if (value === null || value === void 0 ? void 0 : value.length) {
        if ((_a = field === null || field === void 0 ? void 0 : field.legacy) === null || _a === void 0 ? void 0 : _a.localStorage) {
            //Also set old legacy localstorage in case old scripts rely on old fields
            localStorage.setItem(field.legacy.localStorage, value);
        }
        localStorage.setItem(field.uid, value);
    }
};
exports._SaveFieldInLocalstorage = _SaveFieldInLocalstorage;
var _RemoveFieldFromLocalstorage = function (field) {
    var _a;
    if ((_a = field === null || field === void 0 ? void 0 : field.legacy) === null || _a === void 0 ? void 0 : _a.localStorage) {
        //Also set old legacy localstorage in case old scripts rely on old fields
        localStorage.removeItem(field.legacy.localStorage);
    }
    localStorage.removeItem(field.uid);
};
exports._RemoveFieldFromLocalstorage = _RemoveFieldFromLocalstorage;
/**
 * Tries to gather all data that is either in input fields or localstorage
 */
var _ReadAllFields = function (mappings) {
    if (mappings === void 0) { mappings = input_mapping_const_1._AllMappings; }
    var data = {};
    for (var key in mappings) {
        var field = mappings[key];
        var value = (0, exports._ReadFieldValue)(field);
        if (value) {
            lodash_1.default.set(data, field.uid, value);
        }
    }
    return data;
};
exports._ReadAllFields = _ReadAllFields;
/**
 * Gets value from input field, localstorage or defaultValue in this order
 */
var _ReadFieldValue = function (field) {
    var _a;
    var domObject = (0, exports._GetFieldDomObj)(field);
    //by default we search input field, localstorage and default values
    var value = (_a = [(0, exports._ReadFieldFromLocalstorage)(field), field === null || field === void 0 ? void 0 : field.defaultValue].find(function (a) { return a === null || a === void 0 ? void 0 : a.length; })) !== null && _a !== void 0 ? _a : '';
    // The assumption is that if you have a input field on the page you want to overwrite even with empty values
    // Ignore hidden text fields
    if (domObject.length && (0, jquery_helper_const_1._IsVisible)(domObject)) {
        value = (0, exports._ReadField)(field);
    }
    return value;
};
exports._ReadFieldValue = _ReadFieldValue;
/**
 * Returns legacy or new localstorage value for field
 * @param field
 * @returns
 */
var _ReadFieldFromLocalstorage = function (field) {
    var _a;
    var value = localStorage.getItem(field.uid);
    if (!(value === null || value === void 0 ? void 0 : value.length) && ((_a = field === null || field === void 0 ? void 0 : field.legacy) === null || _a === void 0 ? void 0 : _a.localStorage)) {
        //if we have no new value we check old localstorage names and values
        var oldValue = localStorage.getItem(field.legacy.localStorage);
        if (oldValue === null || oldValue === void 0 ? void 0 : oldValue.length) {
            //convert from legacy to new uid
            // disabled, causes issues with legacy: if legacy is used, it saves it in new id storage, but then keeps using the new id storage
            // this causes that changes to legacy storage will not be taken in account, as always the v2 will be taken afterwards and not updated
            // localStorage.setItem(field.uid, oldValue);
            value = oldValue;
        }
    }
    return value || undefined;
};
exports._ReadFieldFromLocalstorage = _ReadFieldFromLocalstorage;
/**
 * Prefill all fields with values from either localstorage or fields themselve
 * @param $container
 */
var _PrefillFields = function ($container, options) {
    if (options === void 0) { options = { mappings: input_mapping_const_1._AllMappings }; }
    for (var key in options.mappings) {
        var field = options.mappings[key];
        if (field === null || field === void 0 ? void 0 : field.disabled) {
            (0, exports._GetFieldDomObj)(field, $container).attr('disabled', 'true');
        }
        if (!options.values && !(0, exports._ShouldPrefillFromLocalStorage)())
            continue;
        var value = (0, exports._ReadFieldFromLocalstorage)(field);
        if (options === null || options === void 0 ? void 0 : options.values) {
            value = lodash_1.default.get(options.values, field.uid);
        }
        // console.log("Writing field", field, "to", value)
        (0, exports._WriteField)(field, value, $container);
    }
};
exports._PrefillFields = _PrefillFields;
/**
 * Only fills out fields marked with data-hidden="true" and using new data-get
 * @param $container
 */
var _PrefillHiddenFields = function () {
    if (!(0, exports._ShouldPrefillFromLocalStorage)())
        return;
    var mappings = __assign(__assign({}, input_mapping_const_1._AllMappings), input_mapping_const_1._BirthdayForm);
    var _loop_1 = function (key) {
        var field = mappings[key];
        (0, cash_dom_1.default)("[data-get=\"".concat(field.uid, "\"]")).each(function (_, element) {
            var el = (0, cash_dom_1.default)(element);
            var isHidden = el.attr('data-hidden') === 'true';
            var hasGet = el.attr('data-get') !== undefined;
            if (!isHidden || !hasGet)
                return;
            var value = (0, exports._ReadFieldFromLocalstorage)(field);
            // for now just write them if we have a value
            if (value !== undefined) {
                console.log('writing data-hidden field', el, 'with value', value);
                (0, exports._WriteField)(field, value);
            }
        });
    };
    for (var key in mappings) {
        _loop_1(key);
    }
};
exports._PrefillHiddenFields = _PrefillHiddenFields;
/**
 * Returns value of legacy input field or modern ui field
 * @param field
 * @param $container
 * @returns
 */
var _ReadField = function (field, $container, dataType) {
    if ($container === void 0) { $container = (0, cash_dom_1.default)('body'); }
    if (dataType === void 0) { dataType = 'get'; }
    var value = undefined;
    if (field.type === 'checkbox') {
        value = (0, exports._ReadRadioField)(field, $container, dataType);
    }
    else if (field.type === 'radio') {
        value = (0, exports._ReadRadioField)(field, $container, dataType);
    }
    else {
        value = (0, exports._GetFieldDomObj)(field, $container, dataType).val();
    }
    return value;
};
exports._ReadField = _ReadField;
/**
 * Returns either some legacy input field or modern uid field
 * @param field
 * @param $container
 * @returns
 */
var _GetFieldDomObj = function (field, $container, dataType) {
    var _a, _b;
    if ($container === void 0) { $container = (0, cash_dom_1.default)('body'); }
    if (dataType === void 0) { dataType = 'get'; }
    var fieldLegacy = $container.find("".concat((_a = field === null || field === void 0 ? void 0 : field.legacy) === null || _a === void 0 ? void 0 : _a.id));
    var fieldLegacy2 = $container.find("".concat((_b = field === null || field === void 0 ? void 0 : field.legacy) === null || _b === void 0 ? void 0 : _b.id2)); //what if legacy id2 is undefined??
    var fieldUid = $container.find("[data-".concat(dataType, "=\"").concat(field.uid, "\"]"));
    var domObject = [fieldUid, fieldLegacy2, fieldLegacy].find(function (a) { return a.length; });
    //console.log("getting field", field.uid, field, "in container", $container, "of type", dataType, "resulting in legacy", fieldLegacy, "legacy2", fieldLegacy2, "V2", fieldUid)
    return domObject !== null && domObject !== void 0 ? domObject : (0, cash_dom_1.default)();
};
exports._GetFieldDomObj = _GetFieldDomObj;
/**
 * Write a value to either dropdown, input or checkbox fields. Automatically detects what to fill where
 * @param field
 * @param value
 * @param $container
 */
var _WriteField = function (field, value, $container) {
    if ($container === void 0) { $container = (0, cash_dom_1.default)('body'); }
    var returnObject = {};
    if (field.type === 'text' || field.type === 'iban') {
        (0, exports._GetFieldDomObj)(field, $container).val(value);
    }
    else if (field.type === 'dropdown') {
        (0, exports._WriteDropdownField)(field, value, $container);
    }
    else if (field.type === 'radio') {
        (0, exports._WriteRadioField)(field, value, $container);
    }
    else if (field.type === 'checkbox') {
        // some parts write undefined or "" or null, which causes the checkbox to be still checked
        // but the function only checks the visible checkbox, not the hidden one, causing errors with webflow validation
        //_WriteCheckboxField(field, value, $container);
    }
    lodash_1.default.set(returnObject, field.uid, value);
    return returnObject;
};
exports._WriteField = _WriteField;
var _ReadRadioField = function (field, $container, dataType) {
    var _a;
    if ($container === void 0) { $container = (0, cash_dom_1.default)('body'); }
    if (dataType === void 0) { dataType = 'get'; }
    //if data-get is the wrapper
    var cont = $container.find("[data-".concat(dataType, "=\"").concat(field.uid, "\"]"));
    var value = (cont.find('input:checked').val() || cont.filter('input:checked').val());
    if (!(value === null || value === void 0 ? void 0 : value.length) && ((_a = field === null || field === void 0 ? void 0 : field.legacy) === null || _a === void 0 ? void 0 : _a.id)) {
        var legacyElem = $container.find(field.legacy.id);
        if (legacyElem.length > 0) {
            var isChecked = $container.find(field.legacy.id).is(':checked');
            value = isChecked ? $container.find(field.legacy.id).val() : '';
        }
        // old version, .val() always returns a valid string
        //value = $container.find(field.legacy.id).val() as string;
    }
    return value;
};
exports._ReadRadioField = _ReadRadioField;
var _ClearFields = function ($container, fields) {
    if (fields === void 0) { fields = input_mapping_const_1._AllMappings; }
    console.info('Clear fields', fields);
    for (var key in fields) {
        var field = fields[key];
        (0, exports._WriteField)(field, '', $container);
    }
};
exports._ClearFields = _ClearFields;
var _WriteCheckboxField = function (field, value, $container) {
    var _a;
    //CURRENTLY NOT LEGACY SUPPORTED
    var cont = $container.find("[data-get=\"".concat(field.uid, "\"]"));
    var checkbox = cont.find('input');
    if (!(checkbox === null || checkbox === void 0 ? void 0 : checkbox.length)) {
        checkbox = cont.filter('input');
    }
    if (!(checkbox === null || checkbox === void 0 ? void 0 : checkbox.length) && ((_a = field === null || field === void 0 ? void 0 : field.legacy) === null || _a === void 0 ? void 0 : _a.id)) {
        checkbox = $container.find(field.legacy.id);
    }
    if (checkbox.length) {
        checkbox.prop('checked', false);
        checkbox.prop('checked', value === null || value === void 0 ? void 0 : value.length);
        if (value === null || value === void 0 ? void 0 : value.length) {
            checkbox.get(0).click();
            checkbox.siblings('.w-checkbox-input').addClass('w--redirected-checked');
        }
        else {
            checkbox.siblings('.w-checkbox-input').removeClass('w--redirected-checked');
        }
    }
};
exports._WriteCheckboxField = _WriteCheckboxField;
var _WriteRadioField = function (field, value, $container) {
    var _a;
    if ($container === void 0) { $container = (0, cash_dom_1.default)('body'); }
    //CURRENTLY NOT LEGACY SUPPORTED
    var cont = $container.find("[data-get=\"".concat(field.uid, "\"]"));
    var radioButtons = cont.find('input[type=radio][value="' + value + '"]');
    if (!(radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.length)) {
        radioButtons = cont.filter('input[type=radio][value="' + value + '"]');
    }
    if (!(radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.length) && ((_a = field === null || field === void 0 ? void 0 : field.legacy) === null || _a === void 0 ? void 0 : _a.id)) {
        radioButtons = $container.find(field.legacy.id);
    }
    if (radioButtons.length) {
        (0, exports._UpdateRenderOfRadioField)(radioButtons, !!(value === null || value === void 0 ? void 0 : value.length));
    }
};
exports._WriteRadioField = _WriteRadioField;
var _UpdateRenderOfRadioField = function (radioButtons, value) {
    radioButtons.prop('checked', false);
    radioButtons.prop('checked', value);
    if (value) {
        radioButtons.get(0).click();
        radioButtons.siblings('.w-radio-input').addClass('w--redirected-checked');
    }
    else {
        radioButtons.siblings('.w-radio-input').removeClass('w--redirected-checked');
    }
};
exports._UpdateRenderOfRadioField = _UpdateRenderOfRadioField;
var _WriteDropdownField = function (field, value, $container) {
    if ($container === void 0) { $container = (0, cash_dom_1.default)('body'); }
    $container
        .find("[data-get=\"".concat(field.uid, "\"]"))
        .find('option[value="' + value + '"]')
        .attr('selected', 'true');
    $container
        .find("".concat(field.legacy.id))
        .find('option[value="' + value + '"]')
        .attr('selected', 'true');
    $container
        .find("".concat(field.legacy.id2))
        .find('option[value="' + value + '"]')
        .attr('selected', 'true');
};
exports._WriteDropdownField = _WriteDropdownField;
var _OverwriteIndirectFormSubmit = function (form, callbackFn) {
    // overwrite enter key and "go" on mobile to still validate form
    form.find('input, textarea').on('keydown', function (e) {
        // Enter key also works for the "go" button on mobile
        if (e.key === 'Enter') {
            console.log('Enter key pressed in input - preventing default behavior');
            e.preventDefault();
            callbackFn();
        }
    });
};
exports._OverwriteIndirectFormSubmit = _OverwriteIndirectFormSubmit;
/**
 * Prevents the form from submitting
 * @param form form to disable submit event from
 */
var _DisableFormSubmit = function (form) {
    form.on('submit', function (e) {
        console.log('submit testing');
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
    });
};
exports._DisableFormSubmit = _DisableFormSubmit;
/**
 * Enables the form to submit again
 * @param form form to enable submit event on
 */
var _EnableFormSubmit = function (form) {
    // Remove the previously bound 'submit' event
    form.off('submit');
};
exports._EnableFormSubmit = _EnableFormSubmit;
